import { createApp } from 'vue';
import Builder from './Builder.vue';
import '$src/assets/style.css'; // Importa CSS global/compartido

// Crear la aplicación Vue
const app = createApp(Builder);

// Montar la aplicación
app.mount('#app');
